import { Participant } from "./Participant";

export class System extends Participant {

}
